module.exports = __webpack_public_path__ + "img/hk-openAccount-bg.34e371aa.png";